import { render, staticRenderFns } from "./listketentuanumum.vue?vue&type=template&id=0128d910&"
import script from "./listketentuanumum.vue?vue&type=script&lang=js&"
export * from "./listketentuanumum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports